import axios from 'axios';
import { EmailRequest } from './EmailRequest';

const SEND_GRID_PROXY_URL = 'https://pedantic-booth-4ba634.netlify.app/.netlify/functions/server/send';

export function sendSendGridEmail(request: EmailRequest) {
  return axios.post(SEND_GRID_PROXY_URL, request.getEmailRequest());
}

function mockSendGridEmail(request: EmailRequest) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      reject(new Error());
    }, 2000);
  });
}
